import { type StateCreator } from 'zustand';

export type PortalSlice = {
  portal: HTMLDivElement | HTMLElement | null;
  setPortal: (portal: HTMLDivElement | HTMLElement | null) => void;
};

export type PortalSliceInitialState = Pick<PortalSlice, 'portal'>;

const INITIAL_PORTAL_STATE = {
  portal: null,
} satisfies PortalSliceInitialState;

export type CreatePortalSlice = (
  initialState: Pick<Partial<PortalSlice>, 'portal'>,
) => StateCreator<PortalSlice, [], [], PortalSlice>;

export const createPortalSlice: CreatePortalSlice = (initialState) => (set) => {
  const mergedInitialState = {
    ...INITIAL_PORTAL_STATE,
    ...initialState,
  };

  return {
    ...mergedInitialState,
    setPortal: (portal) => set({ portal }),
  };
};
